<button
  id="helpWidgetButton"
  mat-icon-button
  (click)="helpWidgetService.showHelpWidget()"
  aria-label="Help"
  type="button"
  tabindex="0"
>
  <mat-icon svgIcon="help" class="medium"></mat-icon>
</button>
